import React from "react";
import "./Vins.css";

function Vins() {
  return (
    <main className="vins-page" aria-labelledby="vins-title">

      {/* ── En-tête ─────────────────────────────────────────── */}
      <header className="vins-header">
        <span className="vins-eyebrow">Cave & sommellerie</span>
        <h1 id="vins-title">
          Notre sélection de <em>vins</em>
        </h1>
        <div className="vins-header-divider" />
        <p className="lead">
          Notre sélection, entre vins de découverte et grands noms.
        </p>
      </header>

      {/* ── Le sommelier ────────────────────────────────────── */}
      <section className="vins-feature" aria-labelledby="vins-feature-title">
        <figure className="vins-feature-photo">
          <img
            src="/images/Vins/vins-chartreuse-1.jpg"
            alt="Sélection de liqueurs Chartreuse"
            loading="lazy"
          />
        </figure>
        <div className="vins-feature-text">
          <span className="vins-feature-tag">Les vins</span>
          <h2 id="vins-feature-title">La cave</h2>
          <div className="vins-feature-bar" aria-hidden="true" />
          <p>
            Tout au long de l'année, Thomas, notre sommelier, déniche avec
            passion des vins, des spiritueux et des alcools singuliers.
          </p>
          <p>
            Une sélection vivante et en constante évolution, pensée pour vous
            faire découvrir de belles bouteilles et vous faire voyager à
            travers les terroirs.
          </p>
        </div>
      </section>

      {/* ── Spiritueux ──────────────────────────────────────── */}
      <section className="vins-spirits" aria-labelledby="vins-spirits-title">
        <div className="vins-spirits-text">
          <span className="vins-spirits-tag">À découvrir aussi</span>
          <h2 id="vins-spirits-title">Spiritueux & alcools singuliers</h2>
          <div className="vins-spirits-bar" aria-hidden="true" />
          <p>
            Chartreuse et autres alcools singuliers viennent compléter la
            sélection, dénichés par Thomas au fil de ses trouvailles.
          </p>
        </div>
        <figure className="vins-spirits-photo">
          <img
            src="/images/Vins/vins-cave-1.jpg"
            alt="Sélection de liqueurs Chartreuse"
            loading="lazy"
          />
        </figure>
      </section>

      {/* ── La carte ────────────────────────────────────────── */}
      <section className="vins-carte" aria-labelledby="vins-carte-title">
        <div className="vins-carte-intro">
          <span className="vins-carte-tag">La carte</span>
          <h2 id="vins-carte-title">Notre carte des vins</h2>
        </div>
        <div className="vins-carte-grid">
          <figure className="vins-carte-page">
            <img
              src="/images/Vins/carte-vin1.jpg"
              alt="Carte des vins Trilogie — page 1"
              loading="lazy"
            />
          </figure>
          <figure className="vins-carte-page">
            <img
              src="/images/Vins/carte-vin2.jpg"
              alt="Carte des vins Trilogie — page 2"
              loading="lazy"
            />
          </figure>
        </div>
      </section>

      {/* ── CTA ─────────────────────────────────────────────── */}
      <div className="vins-cta-section">
        <p className="vins-cta-text">
          Prêt à choisir votre bouteille ?
        </p>
        <a
          href="https://bookings.zenchef.com/results?rid=379037&pid=1001"
          target="_blank"
          rel="noopener noreferrer"
          className="vins-cta-btn"
        >
          Réserver une table
          <span className="vins-cta-arrow" />
        </a>
      </div>

    </main>
  );
}

export default Vins;
